import { render } from "./TimeOut.vue?vue&type=template&id=c4171550&ts=true&style=background-color%3A%20black"
import script from "./TimeOut.vue?vue&type=script&lang=ts"
export * from "./TimeOut.vue?vue&type=script&lang=ts"

import "./TimeOut.vue?vue&type=style&index=0&id=c4171550&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__